export default "__VITE_ASSET__Cjo0naWM__"